import {Grid} from "@mui/material";
import {useState} from "react";
import {useGetInvite} from "hooks/useInvitations";
import {useParams} from "react-router-dom";
import {InvitationPart} from "./InvitationPart";
import {ResponseToInvitation} from "./ResponseToInvitation";
import {InvitationErrorPage} from "./InvitationErrorPage";

export const invitationStatus = {
    INITIAL: 0,
    INVITATION_ACCEPTED: 1,
    INVITATION_REJECTED: 2,
    INVITATION_ERROR: 3,
}

export const Invitations = () => {
    const {id} = useParams();
    const [requestStatus, setRequestStatus] = useState(invitationStatus.INITIAL)
    const {data} = useGetInvite(id, setRequestStatus)
    const title = data ? `${data?.doctor?.firstName} ${data?.doctor?.lastName}` : ''


    return (
        <Grid container>
            {requestStatus === invitationStatus.INVITATION_ERROR ?
                <InvitationErrorPage/> :
                (<>
                    <InvitationPart nameOfDoctor={title} id={id} setRequestStatus={setRequestStatus}/>
                    <ResponseToInvitation requestStatus={requestStatus}/>
                </>)}
        </Grid>
    )
}